import { render, staticRenderFns } from "./awstack.vue?vue&type=template&id=094d1cc9"
import script from "./awstack.vue?vue&type=script&lang=js"
export * from "./awstack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports